import { createContext, useContext } from 'react'

export interface DebugModeContextValue {
  /** Whether debug features are suppressed (user wants to view app as non-debug) */
  debugSuppressed: boolean
  setDebugSuppressed: (suppressed: boolean) => void
}

export const DebugModeContext = createContext<DebugModeContextValue>({
  debugSuppressed: false,
  setDebugSuppressed: () => {},
})

export const useDebugMode = () => useContext(DebugModeContext)
